import type { DataRegion, RegionDetails } from "@/types/auth"

/**
 * Type guard to validate if a value is a valid data region
 */
export const isValidRegion = (value: unknown): value is DataRegion =>
  value === "us" || value === "ca"

/**
 * Validates region details and returns a typed region value if valid
 */
export const validateRegionDetails = (regionDetails?: RegionDetails): DataRegion | undefined => {
  return isValidRegion(regionDetails?.region) ? regionDetails.region : undefined
}

export const REGION_FORMAT: Record<DataRegion, { currency: string; locale: string }> = {
  us: { currency: "USD", locale: "en-US" },
  ca: { currency: "CAD", locale: "en-CA" },
}
